import { render, staticRenderFns } from "./oneRight.vue?vue&type=template&id=41aefa50&"
import script from "./oneRight.vue?vue&type=script&lang=js&"
export * from "./oneRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports